import React, { useState, useEffect } from 'react'
import {
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    Button,
    Typography,
    TextField,
    Grid,
    makeStyles,
    FormControlLabel,
    Checkbox,
} from "@material-ui/core";
import axios from '../../../services/auth/jwt/config'

import GridContainer from "@jumbo/components/GridContainer";
import { Autocomplete } from '@material-ui/lab';
import { useDispatch } from 'react-redux';
import TestsRequests from 'services/tests';

const useStyles = makeStyles((theme) => ({
    girdContainer: {
        width: "100%",
        margin: "0",
        padding: "0",
    },
    customInput: {
        width: "80%",
        [theme.breakpoints.down("lg")]: {
            width: "100%",
        },
    },
    inputContainer: {
        "& p": {
            fontSize: "14px",
            marginBottom: "10px",
        },
    },
    formControl: {
        width: "100%",
    },
}));

const AddScoreDialog = ({ open, handleClose, }) => {
    const classes = useStyles()
    const [inputValue, setInputValue] = useState("");
    const [options, setOptions] = useState([]);
    const [loading, setLoading] = useState(false);
    const [selectedUserId, setSelectedUserId] = useState(null);
    const [score, setscore] = useState()
    const [description, setDescription] = useState("")
    const [checked, setChecked] = useState(false)

    const dispatch = useDispatch()

    const fetchUsers = async (searchString) => {
        try {
            setLoading(true);
            const response = await axios.get(`/user/getallusers`, {
                params: {
                    page: 1,
                    limit: 99,
                    searchString,
                },
            });
            setOptions(response.data.docs || []);
        } catch (error) {
            console.error("Error fetching users:", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchUsers("");
    }, []);

    useEffect(() => {
        if (inputValue) {
            const delayDebounceFn = setTimeout(() => {
                fetchUsers(inputValue);
            }, 300);
            return () => clearTimeout(delayDebounceFn);
        } else {
            setOptions([]);
        }
    }, [inputValue]);

    const handleAddAndClose = () => {
        const data = {
            "targetUserId": selectedUserId,
            "reason": description,
            "score": score,
            "archived": !checked,
        }
        dispatch(TestsRequests.createScore(data));
        setSelectedUserId("");
        setInputValue("");
        setscore();
        setDescription("");
        handleClose();
    }

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            aria-labelledby="alert-add-user-score"
            aria-describedby="alert-add-user-score"
            fullWidth
            maxWidth={"sm"}
        >
            <DialogContent>
                <DialogContentText id="alert-add-user-score-description">
                    اضافه کردن امتیاز
                </DialogContentText>

                <GridContainer className={classes.girdContainer}>
                    <Grid item xs={12} md={6} className={classes.inputContainer}>
                        <Typography>انتخاب کاربر</Typography>
                        <Autocomplete
                            id="userAutocomplete"
                            options={options}
                            getOptionLabel={(option) => option.fullName || ""}
                            isOptionEqualToValue={(option, value) => option._id === value._id}
                            onInputChange={(event, value) => setInputValue(value)}
                            onChange={(event, value) => {
                                setSelectedUserId(value ? value._id : null);
                            }}
                            noOptionsText="موردی یافت نشد"
                            loading={loading}
                            renderOption={(props, option) => {
                                return (
                                    <li {...props}>
                                        {props.fullName}  - {props.nationalCode} - {props.personnelCode}
                                    </li>
                                )
                            }}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label="کاربر"
                                    variant="outlined"
                                    className="customInput"
                                />
                            )}
                        />
                    </Grid>
                    <Grid item xs={12} md={6} className={classes.inputContainer}>
                        <Typography>امتیاز</Typography>
                        <TextField
                            id="score"
                            label="امتیاز"
                            variant="outlined"
                            type='number'
                            className={classes.customInput}
                            value={score}
                            onChange={(e) => setscore(e.target.value)}
                        />
                    </Grid>

                    <Grid item xs={12} md={6} className={classes.inputContainer}>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={checked}
                                    onChange={(e)=>setChecked(e.target.checked)}
                                    color="primary" 
                                />
                            }
                            label="جدول ماهیانه"
                        />
                    </Grid>

                    <Grid item xs={12} className={classes.inputContainer}>
                        <Typography>توضیحات</Typography>
                        <TextField
                            id="description"
                            label="توضیحات"
                            variant="outlined"
                            multiline
                            rows={4}
                            className={classes.customInput}
                            value={description}
                            onChange={(e) => setDescription(e.target.value)}
                        />
                    </Grid>

                </GridContainer>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleAddAndClose} color="primary">
                    اضافه کردن
                </Button>
                <Button onClick={handleClose} color="secondary" autoFocus>
                    انصراف
                </Button>
            </DialogActions>
        </Dialog>
    )
}

export default AddScoreDialog